import styled, { keyframes } from "styled-components";

const draw = keyframes`
  from { stroke-dashoffset: 600; opacity: 0; }
  to { stroke-dashoffset: 0; opacity: 1; }
`;

export const Container = styled.section`
  --gap: clamp(8px, 1.2vw, 12px);
  width: 100%;
  background: #fff;
  container-type: inline-size;
`;

export const Row = styled.div`
  display: grid;
  gap: var(--gap);
  grid-template-columns: repeat(12, minmax(0, 1fr));
  & > *:nth-child(1),
  & > *:nth-child(2),
  & > *:nth-child(3) {
    grid-column: span 4;
  }
`;

export const TailRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--gap);
  margin-top: 12px;
  @container (max-width: 880px) {
    grid-template-columns: 1fr;
  }
`;

export const CardShell = styled.div`
  width: 100%;
`;

export const CardContainer = styled.div`
  background: linear-gradient(180deg, #ffffff 0%, #f9fbff 100%);
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 18px 20px 22px;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.05);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const MetricLabel = styled.span`
  font-size: 13px;
  font-weight: 900;
  color: #0f172a;
`;

export const AvailWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const AvailHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`;

export const DonutBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  flex-wrap: wrap;

  @container (max-width: 860px) {
    flex-direction: column;
    gap: 10px;
  }
`;

export const DonutWrap = styled.div`
  position: relative;
  width: 140px;
  height: 140px;
  flex-shrink: 0;

  .center {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .num {
      font-size: 20px;
      font-weight: 900;
      color: #0f172a;
      line-height: 1;
    }
    .sub {
      font-size: 11px;
      color: #64748b;
    }
  }
`;

export const DonutSvg = styled.svg`
  transform: rotate(-90deg);
  width: 100%;
  height: 100%;
`;

export const DonutSection = styled.circle`
  animation: ${draw} 1s ease forwards;
`;

export const KindList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  min-width: 120px;
`;

export const KindRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  .label {
    font-size: 12px;
    font-weight: 700;
    color: #0f172a;
    text-transform: capitalize;
  }

  .count {
    font-size: 12px;
    font-weight: 900;
    color: #0f172a;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 999px;
    padding: 2px 8px;
  }
`;

export const Dot = styled.i<{ $idx: number }>`
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: ${({ $idx }) => {
    const palette = [
      "#3b82f6",
      "#10b981",
      "#8b5cf6",
      "#f59e0b",
      "#f43f5e",
      "#14b8a6",
      "#6366f1",
    ];
    return palette[$idx % palette.length];
  }};
`;
